export default __webpack_public_path__ + "static/media/living-room-2155376_640.12b0ac06.jpg";